export class WFEVendorAccountEFTActiveStatusParameterDto {
    workflowId: number;
    payeeCode: string;
    communityId: number;
    vendorAccountId: number;
    eftActive: boolean;
}
